<!--
Copyright (c) 2011-present Qualiteam software Ltd. All rights reserved.
See https://www.x-cart.com/license-agreement.html for license details.
-->

<template>
  <div class="input-group-btn">
    <button
      class="search-button"
      data-toggle="dropdown"
      aria-expanded="false">
      <icon
        :name="isActive ? 'searchActive' : 'search'"
        width="17"
        height="17"/>
      <i class="fa fa-caret-down"/>
    </button>
    <ul
      class="dropdown-menu"
      role="menu">
      <li
        v-for="(item, code) in menuItems"
        :key="code"><a
          :data-placeholder="item.name"
          :data-code="code"
          class="dropdown-item"
          href="javascript:void(0)"
          @click="$emit('searchTypeSelected', code)">{{ item.name }}</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SearchBarDropdown',
  props: {
    isActive: {
      type: Boolean,
      default: true,
    },
    menuItems: {
      type: Object,
      default: () => {},
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/input/SearchBarDropdown.vue